// Catálogo da área Ferramentas (menu Gestão). Ferramenta nova = uma entrada aqui + uma rota em
// FerramentasLayout.tsx + uma regra em src/lib/usoRotas.ts.

import { Scissors, UserSearch, type LucideIcon } from 'lucide-react';

export interface Ferramenta {
  /** Vira a rota: /ferramentas/<slug>. */
  slug: string;
  titulo: string;
  descricao: string;
  icone: LucideIcon;
}

export const FERRAMENTAS: Ferramenta[] = [
  {
    slug: 'dividir-pdf',
    titulo: 'Dividir PDF',
    descricao: 'Separe um PDF em vários arquivos: uma página por arquivo, por intervalos ou só as páginas que você escolher.',
    icone: Scissors,
  },
  {
    slug: 'consulta-dados',
    titulo: 'Consulta de dados',
    descricao: 'Nome completo e data de nascimento pelo CPF (ou razão social pelo CNPJ). O que já foi consultado aparece na hora, sem gastar crédito.',
    icone: UserSearch,
  },
];
